import React, { FC } from 'react';
import { PaymentDetailsType } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import { usePurchaseContext } from 'QuoteApp/services/providers';
import { useAppContext } from 'QuoteApp/services/providers';
import { ContactInfo, ContactInfoV2 } from './ContactInfo';
import { Disclaimer } from './Disclaimer';
import { PaymentDisclaimer } from './PaymentDisclaimer';
import { PaymentFrequencies } from './PaymentFrequencies';
import { PaymentMethods } from './PaymentMethods';
import { OchoPaymentMethod } from './OchoPaymentMethod';

import styles from './styles.module.css';

export const MainContent: FC<{
  paymentDetails: PaymentDetailsType;
}> = ({ paymentDetails }) => {
  const {
    paymentMethodsSectionRef,
    isEditingContactInfo,
    setIsEditingContactInfo,
  } = usePurchaseContext();

  const { details, config } = useAppContext();

  const agentSignature2FeatureFlag = !!details.commands.sendSignaturePacket;
  const isPaymentFlexibilityEnabled = config?.flexiblePayments.enabled;

  const renderPaymentFrequencies = () => {
    return (
      <div className={styles.mainSection}>
        <h3>Payment frequency</h3>
        <PaymentFrequencies paymentDetails={paymentDetails} />
      </div>
    );
  };

  return (
    <div className={styles.mainWrapper}>
      {!isPaymentFlexibilityEnabled && renderPaymentFrequencies()}
      {paymentDetails.paymentProvider === 'adyen' && (
        <div
          className={styles.mainSection}
          ref={paymentMethodsSectionRef}
          data-testid="payment-methods"
        >
          <h3>Payment method</h3>
          <PaymentDisclaimer variant="warning" />
          <PaymentMethods paymentDetails={paymentDetails} />
        </div>
      )}
      {paymentDetails.paymentProvider === 'agentPay' && (
        <div className={styles.mainSection}>
          <h3>Payment method</h3>
          <OchoPaymentMethod />
        </div>
      )}
      <div className={styles.mainSection}>
        {agentSignature2FeatureFlag ? (
          <ContactInfoV2 setIsEditing={setIsEditingContactInfo} />
        ) : (
          <ContactInfo
            isEditing={isEditingContactInfo}
            setIsEditing={setIsEditingContactInfo}
          />
        )}
      </div>
      {!agentSignature2FeatureFlag && (
        <div className={styles.mainSection}>
          <Disclaimer />
        </div>
      )}
      {paymentDetails.paymentProvider === 'processOne' && (
        <div className={styles.mainSection}>
          <h3>Payment method will be collected next</h3>
          <PaymentDisclaimer variant="light-brand" />
        </div>
      )}
    </div>
  );
};
